import { pushCollectIncident } from '/fp/collect-incidents.js';

export default async function isCanvasResistant() {
    const incidents = [];
    try {
        let width = 10;
        let height = 10;
        let canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d', { desynchronized: true, preserveDrawingBuffer: true });
        if (!ctx) return { canvas: null, incidents };
        ctx.fillStyle = "rgb(200, 0, 0)";
        ctx.fillRect(0, 0, width, height);
        let dataurl = canvas.toDataURL();

        let canvas2 = document.createElement('canvas');
        let ctx2 = canvas2.getContext('2d', { willReadFrequently: true });
        if (!ctx2) return { canvas: null, incidents };

        let imageLoaded;
        let data;
        let imagePromise = new Promise(res => imageLoaded = res).then((failed) => {
            if (failed) {
                pushCollectIncident(incidents, {
                    source: 'resistance',
                    phase: 'imageLoad',
                    error: new Error('resistance image failed to load'),
                });
                return { canvas: null, incidents };
            }
            try {
                ctx2.drawImage(img, 0, 0);
                let prevents = false;

                for (let i = 0; i < 10; i++) {
                    for (let j = 0; j < 10; j++) {
                        data = ctx2.getImageData(i, j, 1, 1).data;
                        if (data[3] != 255 || data[1] != 0 || data[2] != 0 || data[0] != 200) {
                            prevents = true;
                            break;
                        }
                    }
                    if (prevents) break;
                }

                return { canvas: prevents, incidents };
            } catch (e) {
                pushCollectIncident(incidents, { source: 'resistance', phase: 'getImageData', error: e });
                return { canvas: null, incidents };
            }
        });

        let img = new Image;
        img.onload = () => imageLoaded(false);
        img.onerror = () => imageLoaded(true);
        img.src = dataurl;

        return imagePromise;
    } catch (e) {
        pushCollectIncident(incidents, { source: 'resistance', phase: 'setup', error: e });
        return { canvas: null, incidents };
    }
}
